import React, { useRef, useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './EditMapPage.css'; // Importa el CSS específico para este componente
import SaveIcon from '@mui/icons-material/Save';
import IconSelector from '../commons/IconSelector';
import {
Autocomplete,Button, TextField, Box, Snackbar, Alert ,List, ListItem,ListItemText,IconButton,
 Grid, Dialog,DialogActions,DialogContent,DialogTitle,Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ColorPicker from '../buses/ColorPicker'; // Importa el ColorPicker
import BusCheckboxes from './BusCheckboxes';

const EditMapPage = () => {
const { id } = useParams();
const [data, setData] = useState([]);
const [zona, setZona] = useState('');
 const [puntosInteres, setPuntosInteres] = useState([]);
  const [poligonos, setPoligonos] = useState([]);

const [saveMapOpen, setSaveMapOpen] = useState(false);
const [excelCargado, setExcelCargado] = useState(false);
const [alertOpen, setAlertOpen] = useState(false);
const [alertMessage, setAlertMessage] = useState('');
const [alertSeverity, setAlertSeverity] = useState('success');
const [map, setMap] = useState(null); // Guardar la instancia del mapa
const [polygon, setPolygon] = useState(null); // Guardar la instancia del polígono
const [selectedElements, setSelectedElements] = useState([]);
const [filters, setFilters] = useState({
  punto: '',
  linea: '',
  poligono: '',
});
const [markers, setMarkers] = useState([]);
const [mapName, setMapName] = useState(''); // Para el nombre del mapa
const [initialLoad, setInitialLoad] = useState(true);
const [newPointDialogOpen, setNewPointDialogOpen] = useState(false);
const [newPointPosition, setNewPointPosition] = useState(null);
const [newPointName, setNewPointName] = useState('');
const [selectedIcon, setSelectedIcon] = useState('https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png');
const [pointData, setPointData] = useState(null);
const [isCreatingPolygon, setIsCreatingPolygon] = useState(false);
const [currentPolygon, setCurrentPolygon] = useState(null);
const [polygonDialogOpen, setPolygonDialogOpen] = useState(false);
const [polygonColor, setPolygonColor] = useState('#388e3c');
const infoWindowRef = useRef(null); 
const [layersVisibility, setLayersVisibility] = useState({});
const [showLayersPanel, setShowLayersPanel] = useState(false);
const [deletedMarkers, setDeletedMarkers] = useState(() => {
  const saved = localStorage.getItem('deletedMarkers');
  return saved ? JSON.parse(saved) : [];
});
const [saveMarkersDialogOpen, setSaveMarkersDialogOpen] = useState(false);
const [newListName, setNewListName] = useState('');
const [combinedMarkers, setCombinedMarkers] = useState([]);
const [searchAddress, setSearchAddress] = useState('');
const [foundLocation, setFoundLocation] = useState(null);
const [markerToEdit, setMarkerToEdit] = useState(null);
const [temporalMarkers, setTemporalMarkers] = useState([]);
const [iconDialogOpen, setIconDialogOpen] = useState(false);
const [mapLinesFromJson, setMapLinesFromJson] = useState({});
const [availableBusRoutes, setAvailableBusRoutes] = useState([]);
const [linesToAutoLoad, setLinesToAutoLoad] = useState([]);
const [hasAutoLoadedLines, setHasAutoLoadedLines] = useState(false);



useEffect(() => {
  if (window.google) {
    initMap();
  } else {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD1Nl9yulU0jgl6VRGkK89neIalMrblrws&callback=initMap`;
    script.async = true;
    document.body.appendChild(script);
    window.initMap = initMap; // Asigna la función al objeto window
  }
}, []);

useEffect(() => {
  fetchData();
}, [filters]);

useEffect(() => {
  
  if (map) {
    fetchMapDetails();
  }
}, [map]);

const cleanMapObjects = (objects) => {
  if (!objects) return;
  
  if (Array.isArray(objects)) {
    objects.forEach(obj => {
      if (obj && obj.setMap) {
        window.google.maps.event.clearInstanceListeners(obj);
        obj.setMap(null);
      }
    });
  } else if (objects && objects.setMap) {
    window.google.maps.event.clearInstanceListeners(objects);
    objects.setMap(null);
  }
};

const renderMarkers = (map, markersData, isVisible, infoWindow) => {
  return markersData
    .filter(pointData => {
      // Filtrar puntos sin coordenadas o marcados como eliminados
      const markerId = String(pointData.id || pointData.nombre);
      return pointData.lat && pointData.lng && !deletedMarkers.includes(markerId);
    })
    .map(pointData => {
      const markerTitle = String(pointData.id || pointData.nombre || `marker-${Date.now()}`);
      
      const marker = new window.google.maps.Marker({
        position: { 
          lat: parseFloat(pointData.lat), 
          lng: parseFloat(pointData.lng) 
        },
        map: isVisible ? map : null,
        title: markerTitle,
        icon: {
          url: pointData.icono || 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png',
          scaledSize: new window.google.maps.Size(32, 32)
        }
      });

      // Evento para eliminar el marcador al hacer clic
      marker.addListener('click', (e) => {
        e.domEvent.stopPropagation(); // Detener la propagación para evitar conflictos
        
        // Confirmar antes de eliminar
        if (window.confirm('¿Estás seguro de querer eliminar este marcador?')) {
          const markerId = String(pointData.id || pointData.nombre);
          addToDeletedMarkers(markerId);
          marker.setMap(null); // Quitar del mapa inmediatamente
          
          // Actualizar el estado para reflejar el cambio
          setSelectedElements(prev => prev.map(el => {
            if (el.type === 'punto' && el.data.some(p => String(p.id || p.nombre) === markerId)) {
              return {
                ...el,
                data: el.data.filter(p => String(p.id || p.nombre) !== markerId),
                markers: el.markers?.filter(m => m !== marker) || []
              };
            }
            return el;
          }));
        }
      });

      if (infoWindow) {
        marker.addListener('click', (e) => {
          e.domEvent.stopPropagation();
          infoWindow.setContent(`
            <div class="info-window">
              <h3>${pointData.nombre || 'Sin nombre'}</h3>
              ${pointData.direccion ? `<p>${pointData.direccion}</p>` : ''}
            </div>
          `);
          infoWindow.open(map, marker);
        });
      }

      return marker;
    })
    .filter(Boolean); 
};



//metodo para renderizado
useEffect(() => {
  if (!map || !window.google) return;

  let isMounted = true;
  const cleanupFunctions = [];

  const renderMapElements = () => {
    // Limpiar TODOS los elementos del mapa primero
    selectedElements.forEach(element => {
      if (element.markers) {
        element.markers.forEach(marker => {
          if (marker && marker.setMap) marker.setMap(null);
        });
      }
      if (element.polyline) {
        if (Array.isArray(element.polyline)) {
          element.polyline.forEach(poly => poly.setMap(null));
        } else {
          element.polyline.setMap(null);
        }
      }
      if (element.polygon) {
        if (Array.isArray(element.polygon)) {
          element.polygon.forEach(poly => poly.setMap(null));
        } else {
          element.polygon.setMap(null);
        }
      }
    });

    // Renderizar solo los elementos visibles
    const updatedElements = selectedElements.map(element => {
      const layerKey = `${element.type}-${element.nombre}`;
      const isVisible = layersVisibility[layerKey] !== false;
      
      // Si el elemento no está visible, no lo renderizamos
      if (!isVisible) {
        return { ...element, markers: [], polyline: null, polygon: null };
      }

      switch (element.type) {
        case 'punto':
          const puntosVisibles = element.data.filter(punto => 
            punto.lat && punto.lng && !deletedMarkers.includes(String(punto.id || punto.nombre))
          );
          
          const newMarkers = puntosVisibles.map(pointData => {
            const marker = new window.google.maps.Marker({
              position: { 
                lat: parseFloat(pointData.lat), 
                lng: parseFloat(pointData.lng) 
              },
              map: map,
              title: String(pointData.id || pointData.nombre || `marker-${Date.now()}`),
              icon: {
                url: pointData.icono || 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png',
                scaledSize: new window.google.maps.Size(32, 32)
              }
            });

            // Evento para eliminar
            marker.addListener('click', (e) => {
              e.domEvent.stopPropagation();
              if (window.confirm('¿Estás seguro de querer eliminar este marcador?')) {
                const markerId = String(pointData.id || pointData.nombre);
                addToDeletedMarkers(markerId);
                marker.setMap(null);
              }
            });

            // InfoWindow
            if (infoWindowRef.current) {
              marker.addListener('click', (e) => {
                e.domEvent.stopPropagation();
                infoWindowRef.current.setContent(`
                  <div class="info-window">
                    <h3>${pointData.nombre || 'Sin nombre'}</h3>
                    ${pointData.direccion ? `<p>${pointData.direccion}</p>` : ''}
                  </div>
                `);
                infoWindowRef.current.open(map, marker);
              });
            }

            return marker;
          });

          return { ...element, markers: newMarkers };

        case 'linea':
        case 'bus':
          if (!element.data?.length) return element;
          
          const validPoints = element.data
            .sort((a, b) => (a.sequence_order || 0) - (b.sequence_order || 0))
            .filter(p => p.lat && p.lng);

          if (validPoints.length === 0) return element;

          const lineColor = element.data[0]?.color || element.color || '#FF0000';
          const polyline = new window.google.maps.Polyline({
            path: validPoints.map(p => ({
              lat: parseFloat(p.lat),
              lng: parseFloat(p.lng)
            })),
            strokeColor: lineColor,
            strokeOpacity: 1.0,
            strokeWeight: 4,
            map: map
          });

          return { ...element, polyline };

        case 'polygon':
          const polygonPath = element.data
            .filter(p => p.lat && p.lng)
            .map(p => ({
              lat: parseFloat(p.lat),
              lng: parseFloat(p.lng)
            }));

          if (polygonPath.length < 3) return element;

          const polygonColor = element.data[0]?.color || element.color || '#388e3c';
          const polygon = new window.google.maps.Polygon({
            paths: polygonPath,
            strokeColor: polygonColor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: polygonColor,
            fillOpacity: 0.35,
            map: map
          });

          return { ...element, polygon };

        default:
          return element;
      }
    });

    if (isMounted) {
      setSelectedElements(updatedElements);
    }
  };

  // Debounce para evitar renderizados múltiples
  const timer = setTimeout(() => {
    if (isMounted) {
      renderMapElements();
    }
  }, 100);

  cleanupFunctions.push(() => {
    isMounted = false;
    clearTimeout(timer);
  });

  return () => {
    cleanupFunctions.forEach(fn => fn());
  };
}, [map, selectedElements.length, layersVisibility, deletedMarkers]);



//metodo para crear capa forma con click
useEffect(() => {
  if (!map) return;

  // Limpiar listeners anteriores
  window.google.maps.event.clearListeners(map, 'dblclick');
  window.google.maps.event.clearListeners(map, 'click');

  if (isCreatingPolygon) {
    // Configuración para creación de polígonos
    map.setOptions({ draggableCursor: 'crosshair' });
    
    const handleClick = (e) => {
      if (!currentPolygon) {
        // Crear nuevo polígono si no existe
        const newPolygon = new window.google.maps.Polygon({
          paths: [{
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
          }],
          strokeColor: polygonColor,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: polygonColor,
          fillOpacity: 0.35,
          editable: true,
          draggable: true,
          map: map
        });
        setCurrentPolygon(newPolygon);
      } else {
        // Agregar punto al polígono existente
        const path = currentPolygon.getPath();
        path.push(e.latLng);
      }
    };

    map.addListener('click', handleClick);

    return () => {
      window.google.maps.event.clearListeners(map, 'click');
    };
  } else {
    // Configuración normal para agregar puntos de interés
    map.setOptions({ draggableCursor: '' });
    
    const handleDoubleClick = (e) => {
      setNewPointPosition({
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      });
      setNewPointDialogOpen(true);
    };

    map.addListener('dblclick', handleDoubleClick);

    return () => {
      window.google.maps.event.clearListeners(map, 'dblclick');
    };
  }
}, [map, isCreatingPolygon, currentPolygon, polygonColor]);

//funcion para agregar el dialog de nueva lista : 
const handleOpenSaveMarkersDialog = () => {
  const allMarkers = selectedElements
    .filter(el => el.type === 'punto' && el.data)
    .flatMap(element => 
      element.data.filter(punto => 
        punto && !isNaN(punto.lat) && !isNaN(punto.lng) && 
        !deletedMarkers.includes(punto.id || punto.nombre)
      )
    );

  if (allMarkers.length === 0) {
    setAlertMessage('No hay marcadores válidos para guardar');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  setCombinedMarkers(allMarkers);
  setSaveMarkersDialogOpen(true);
};
//funcion para quitar los marcadores 
const handleRemoveIndividualMarker = (listName, markerId) => {
  const idString = String(markerId);
  
  setDeletedMarkers(prev => {
    const updated = [...prev, idString];
    localStorage.setItem('deletedMarkers', JSON.stringify(updated));
    return updated;
  });

  // Forzar re-renderizado de los elementos
  setSelectedElements(prev => [...prev]);
};


//funcion para geocoding de direccion input
const handleSearchAddress = async () => {
  if (!searchAddress.trim()) {
    setAlertMessage('Por favor ingresa una dirección');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json`,
      {
        params: {
          address: searchAddress,
          key: 'AIzaSyDhV1-TmsTWBVC3TMbc_ATcflMHSC2Y9Wo',
        },
      }
    );

    if (response.data.status === 'OK') {
      const location = response.data.results[0].geometry.location;
      const addressComponents = response.data.results[0].address_components;
      
      const localidad = addressComponents.find(component => 
        component.types.includes('locality')
      )?.long_name || '';

      // Guardar la información del marcador temporalmente
      setMarkerToEdit({
        lat: location.lat,
        lng: location.lng,
        direccion: searchAddress,
        localidad,
        nombre: `Marcador ${temporalMarkers.length + 1}`,
        temporalId: Date.now() // ID único
      });

      // Abrir automáticamente el diálogo de íconos
      setIconDialogOpen(true);
      
      setSearchAddress('');
    } else {
      throw new Error('No se encontró la dirección');
    }
  } catch (error) {
    console.error('Error al buscar dirección:', error);
    setAlertMessage('Error al buscar dirección: ' + error.message);
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

//funcion para añadir marcador al mapa por direccion
const handleAddTemporalMarker = (icon) => {
  if (!markerToEdit || !icon) return;

  const newMarker = {
    ...markerToEdit,
    icono: icon,
    nombre: `Marcador ${temporalMarkers.length + 1}`
  };

  // Crear el marcador en el mapa
  const marker = new window.google.maps.Marker({
    position: { lat: newMarker.lat, lng: newMarker.lng },
    map,
    title: newMarker.nombre,
    icon: {
      url: icon,
      scaledSize: new window.google.maps.Size(32, 32)
    }
  });

  // Permitir eliminar el marcador con clic derecho
  marker.addListener('rightclick', () => {
    marker.setMap(null);
    setTemporalMarkers(prev => prev.filter(m => 
      m.lat !== newMarker.lat || m.lng !== newMarker.lng
    ));
  });

  // Agregar a la lista de temporales
  setTemporalMarkers([...temporalMarkers, newMarker]);
  
  // Agregar al estado de elementos seleccionados
  setSelectedElements(prev => [
    ...prev,
    {
      nombre: `Temporal-${Date.now()}`,
      type: 'punto',
      data: [newMarker],
      markers: [marker],
      isTemporal: true
    }
  ]);

  setAlertMessage('Marcador añadido');
  setAlertSeverity('success');
  setAlertOpen(true);
  
  // Cerrar diálogos y limpiar estado
  setIconDialogOpen(false);
  setMarkerToEdit(null);
};

//añade marcador temporal a la lista capa marcador 

const handleSaveTemporalMarkers = async () => {
  if (!newListName.trim()) {
    setAlertMessage('Por favor ingresa un nombre para la lista');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  try {
    // Filtrar marcadores temporales únicos
    const uniqueMarkers = temporalMarkers.reduce((acc, current) => {
      const x = acc.find(item => 
        item.lat === current.lat && item.lng === current.lng
      );
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    const response = await axios.post('https://mapa.ne3publicidad.com.ar/api/api/uploadPuntosInteres', {
      data: uniqueMarkers,
      nombre: newListName,
      icono: uniqueMarkers[0]?.icono || 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png'
    });

    // Actualizar el estado con los marcadores guardados
    setSelectedElements(prev => [
      ...prev.filter(el => !el.isTemporal),
      {
        nombre: newListName,
        type: 'punto',
        data: uniqueMarkers,
        markers: uniqueMarkers.map(marker => ({
          ...marker,
          mapMarker: new window.google.maps.Marker({
            position: { lat: marker.lat, lng: marker.lng },
            map,
            title: marker.nombre,
            icon: {
              url: marker.icono,
              scaledSize: new window.google.maps.Size(32, 32)
            }
          })
        }))
      }
    ]);

    // Limpiar temporales
    setTemporalMarkers([]);
    setNewListName('');
    
    setAlertMessage('Marcadores guardados exitosamente');
    setAlertSeverity('success');
    setAlertOpen(true);
  } catch (error) {
    console.error('Error al guardar marcadores:', error);
    setAlertMessage('Error al guardar marcadores: ' + error.message);
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};


// Función para añadir un marcador a la lista de eliminados
const addToDeletedMarkers = (markerId) => {
  setDeletedMarkers(prev => {
    // Evitar duplicados
    if (prev.includes(markerId)) return prev;
    
    const updated = [...prev, markerId];
    try {
      localStorage.setItem('deletedMarkers', JSON.stringify(updated));
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
    return updated;
  });
};

// Función para limpiar los marcadores eliminados
const clearDeletedMarkers = () => {
  setDeletedMarkers([]);
  try {
    localStorage.removeItem('deletedMarkers');
  } catch (error) {
    console.error("Error clearing localStorage:", error);
  }
  // Forzar re-renderizado
  setSelectedElements(prev => [...prev]);
};

const handleSaveCombinedMarkers = async () => {
  if (!newListName.trim()) {
    setAlertMessage('Por favor ingresa un nombre para la lista');
    setAlertSeverity('warning');
    setAlertOpen(true);
    return;
  }

  try {
    // Agrupar marcadores por icono para preservarlos
    const markersByIcon = combinedMarkers.reduce((acc, marker) => {
      const iconKey = marker.icono || 'default';
      if (!acc[iconKey]) {
        acc[iconKey] = [];
      }
      acc[iconKey].push(marker);
      return acc;
    }, {});

    // Guardar cada grupo con su icono correspondiente
    await Promise.all(
      Object.entries(markersByIcon).map(async ([icon, markers]) => {
        await axios.post('https://mapa.ne3publicidad.com.ar/api/api/uploadPuntosInteres', {
          data: markers.map(marker => ({
            ...marker,
            nombre: newListName
          })),
          nombre: newListName,
          icono: icon !== 'default' ? icon : 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png'
        });
      })
    );

    // Actualizar el estado
    const updatedElements = [
      ...selectedElements.filter(el => el.type !== 'punto'),
      { 
        nombre: newListName, 
        type: 'punto', 
        data: combinedMarkers 
      }
    ];

    setSelectedElements(updatedElements);
    setAlertMessage('Lista guardada exitosamente');
    setAlertSeverity('success');
    setAlertOpen(true);
    
    // Cerrar diálogo de lista y abrir diálogo de mapa
    setSaveMarkersDialogOpen(false);
    setSaveMapOpen(true);
    setNewListName('');
    
  } catch (error) {
    console.error('Error al guardar:', error);
    setAlertMessage('Error al guardar la lista');
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

//funcion para guardar la capa forma 
const handleSaveNewPoint = async () => {
  if (!newPointName || !newPointPosition || !selectedIcon) {
    setAlertMessage('Todos los campos son requeridos');
    setAlertSeverity('error');
    setAlertOpen(true);
    return;
  }

  try {
    // 1. Obtener dirección mediante geocodificación inversa
    const geocodeResponse = await axios.get(
      'https://maps.googleapis.com/maps/api/geocode/json',
      {
        params: {
          latlng: `${newPointPosition.lat},${newPointPosition.lng}`,
          key: 'AIzaSyDhV1-TmsTWBVC3TMbc_ATcflMHSC2Y9Wo',
          language: 'es'
        }
      }
    );

    if (geocodeResponse.data.status !== 'OK') {
      throw new Error('No se pudo obtener la dirección');
    }

    // 2. Extraer dirección y localidad
    const result = geocodeResponse.data.results[0];
    const direccion = result.formatted_address;
    
    // Función auxiliar para extraer la localidad
    const getLocality = (components) => {
      const locality = components.find(comp => 
        comp.types.includes('locality') || 
        comp.types.includes('administrative_area_level_2')
      );
      return locality ? locality.long_name : 'Localidad no disponible';
    };
    
    const localidad = getLocality(result.address_components);

    // 3. Preparar datos del punto
     const pointData = {
    id: Date.now().toString(), // Generar un ID único
    direccion,
    localidad,
    lat: newPointPosition.lat.toString(),
    lng: newPointPosition.lng.toString(),
    icono: selectedIcon
  };

    // 4. Guardar en el backend
    await axios.post('https://mapa.ne3publicidad.com.ar/api/api/uploadPuntosInteres', {
      data: [pointData],
      nombre: newPointName,
      icono: selectedIcon
    });

    // 5. Actualizar el estado
    const newPointElement = {
      nombre: newPointName,
      type: 'punto',
      data: [pointData],
      marker: null
    };

    setSelectedElements(prev => [...prev, newPointElement]);
    
    setAlertMessage('Punto de interés guardado exitosamente');
    setAlertSeverity('success');
    setAlertOpen(true);
    
    // 6. Resetear el formulario
    setNewPointName('');
    setSelectedIcon('https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png');
    setNewPointDialogOpen(false);
  } catch (error) {
    console.error('Error al guardar el punto:', error);
    setAlertMessage(error.response?.data?.message || 'Error al guardar el punto de interés');
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

const handleRemoveElement = (nombre, type) => {
  setSelectedElements(prev => {
    const elementsToRemove = prev.filter(el => {
      // Caso normal: nombre y tipo exacto
      if (el.nombre === nombre && el.type === type) return true;
      
      // Caso líneas de bus
      if (type === 'bus' && el.type === 'bus' && 
          el.nombre.startsWith(nombre.replace(/[^0-9]/g, ''))) {
        return true;
      }
      
      // Caso grupos de puntos
      if (type === 'punto' && el.type === 'punto' && 
          nombre.replace(/-\d+$/, '') === el.nombre.replace(/-\d+$/, '')) {
        return true;
      }
      
      return false;
    });
    
    // Limpiar objetos del mapa de forma más efectiva
    elementsToRemove.forEach(element => {
      // Limpiar markers
      if (element.markers && Array.isArray(element.markers)) {
        element.markers.forEach(marker => {
          if (marker) {
            window.google.maps.event.clearInstanceListeners(marker);
            if (marker.setMap) marker.setMap(null);
          }
        });
      }
      
      // Limpiar polyline
      if (element.polyline) {
        if (Array.isArray(element.polyline)) {
          element.polyline.forEach(poly => {
            if (poly) {
              window.google.maps.event.clearInstanceListeners(poly);
              if (poly.setMap) poly.setMap(null);
            }
          });
        } else if (element.polyline.setMap) {
          window.google.maps.event.clearInstanceListeners(element.polyline);
          element.polyline.setMap(null);
        }
      }
      
      // Limpiar polygon
      if (element.polygon) {
        if (Array.isArray(element.polygon)) {
          element.polygon.forEach(poly => {
            if (poly) {
              window.google.maps.event.clearInstanceListeners(poly);
              if (poly.setMap) poly.setMap(null);
            }
          });
        } else if (element.polygon.setMap) {
          window.google.maps.event.clearInstanceListeners(element.polygon);
          element.polygon.setMap(null);
        }
      }
    });

    return prev.filter(el => !elementsToRemove.includes(el));
  });
};


const initMap = () => {
  const mapInstance = new window.google.maps.Map(document.getElementById('map'), {
    center: { lat: -34.603722, lng: -58.381592 },
    zoom: 12,
    gestureHandling: "greedy", // Mejor control de gestos en móviles
    disableDefaultUI: false, // Mantener controles básicos
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }] // Ocultar puntos de interés
      }
    ]
  });

  // Inicializar InfoWindow para tooltips
  infoWindowRef.current = new window.google.maps.InfoWindow({
    maxWidth: 250,
    disableAutoPan: false, // Permite ajustar el mapa para mostrar el tooltip
    pixelOffset: new window.google.maps.Size(0, -10) // Desplazamiento vertical
  });

  // Configurar evento de clic en el mapa para cerrar tooltips
  mapInstance.addListener('click', () => {
    if (infoWindowRef.current) {
      infoWindowRef.current.close();
    }
  });

  setMap(mapInstance);
};

const fetchMapDetails = async () => {
  try {
    const response = await axios.get(`https://mapa.ne3publicidad.com.ar/api/api/getMap/${id}`);
    const { lineas, puntosInteres, poligonos } = response.data;

    // Procesamiento optimizado de los datos
    const elements = [];

    // 1. PROCESAR LÍNEAS DEL JSON Y CARGARLAS AUTOMÁTICAMENTE
    const lineGroups = lineas.reduce((acc, line) => {
      if (!acc[line.linea]) {
        acc[line.linea] = [];
      }
      acc[line.linea].push(line);
      return acc;
    }, {});

    // Agregar cada línea al estado selectedElements para que se renderice en el mapa
    Object.entries(lineGroups).forEach(([lineName, points]) => {
      elements.push({
        nombre: lineName,
        type: 'bus', // Cambiar de 'linea' a 'bus' para consistencia
        data: points,
        color: points[0]?.color || '#FF0000'
      });
    });

    // 2. Procesar puntos de interés agrupados
    const pointGroups = puntosInteres.reduce((acc, point) => {
      const groupName = point.nombre;
      if (!acc[groupName]) {
        acc[groupName] = [];
      }
      acc[groupName].push(point);
      return acc;
    }, {});

    Object.entries(pointGroups).forEach(([groupName, points]) => {
      elements.push({
        nombre: groupName,
        type: 'punto',
        data: points,
        count: points.length
      });
    });

    // 3. Procesar polígonos
    poligonos.forEach(polygonGroup => {
      if (polygonGroup.length > 0) {
        elements.push({
          nombre: polygonGroup[0].nombre_zona,
          type: 'polygon',
          data: polygonGroup.sort((a, b) => a.punto_orden - b.punto_orden),
          color: polygonGroup[0]?.color || '#388e3c'
        });
      }
    });

    // 4. Extraer los números base de las líneas para los checkboxes
    const uniqueBaseRoutes = Object.keys(lineGroups).map(lineName => 
      lineName.replace(/[^0-9]/g, '')
    ).filter((value, index, self) => self.indexOf(value) === index);

    setSelectedElements(elements);
    setAvailableBusRoutes(uniqueBaseRoutes); // Para que BusCheckboxes sepa qué líneas marcar
    setMapLinesFromJson(lineGroups); // Datos completos de las líneas

    console.log("Líneas cargadas automáticamente:", uniqueBaseRoutes);
    
  } catch (error) {
    console.error('Error fetching map details:', error);
    setAlertMessage('Error al cargar los detalles del mapa');
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};


const openSaveMapPopup = () => {
  if (deletedMarkers.length > 0) {
    // Si hay marcadores eliminados, primero abre el diálogo para la nueva lista
    handleOpenSaveMarkersDialog();
  } else {
    // Si no hay eliminados, abre directamente el diálogo del mapa
    setSaveMapOpen(true);
  }
};
const closeSaveMapPopup = () => {
setSaveMapOpen(false);
};


const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        if (!sheet) {
          throw new Error('No se pudo leer la hoja del archivo');
        }

        const json = XLSX.utils.sheet_to_json(sheet);

        if (json.length === 0) {
          throw new Error('La hoja está vacía');
        }

        setData(json);
        setExcelCargado(true);
        drawPolygon(json); // Dibuja el polígono en el mapa
      } catch (error) {
        console.error('Error al procesar el archivo:', error.message);
        setData([]);
        setExcelCargado(false);
        setAlertMessage('Error al cargar el archivo');
        setAlertSeverity('error');
        setAlertOpen(true);
      }
    };

    reader.readAsArrayBuffer(file);
  }
};

const handleSelectElement = (nombre, data, type, color) => {
  setSelectedElements(prev => {
    const existingIndex = prev.findIndex(el => 
      el.nombre === nombre && el.type === type
    );

    if (existingIndex >= 0) {
      // Si existe, lo eliminamos
      const newElements = [...prev];
      const [removed] = newElements.splice(existingIndex, 1);
      // Limpiar el elemento del mapa
      if (removed.marker) removed.marker.setMap(null);
      if (removed.polyline) removed.polyline.setMap(null);
      if (removed.polygon) removed.polygon.setMap(null);
      return newElements;
    } else {
      // Si no existe, lo agregamos
      const newElement = { 
        nombre, 
        data: Array.isArray(data) ? 
          data.map((item, index) => ({
            ...item,
            sequence_order: item.sequence_order || index + 1,
            color: item.color || color // Usar color del punto o el color proporcionado
          })) : 
          [{ ...data, sequence_order: 1, color: data.color || color }],
        type,
        color: color || '#FF0000', // Color por defecto si no viene
        id: `${nombre}-${type}-${Date.now()}`,
        marker: null,
        polyline: null,
        polygon: null
      };
      
      return [...prev, newElement];
    }
  });
};

//metodo para guardar el mapa llamado al backend 
const handleSaveMap = async () => {
  try {
    // Validación del nombre del mapa
    if (!mapName) throw new Error('El nombre del mapa es requerido');

    // 1. Obtener marcadores eliminados del localStorage
    const savedDeletedMarkers = JSON.parse(localStorage.getItem('deletedMarkers') || '[]');

    // 2. Obtener elementos TEMPORALES no guardados
    const temporalMarkersToSave = selectedElements
      .filter(el => el.isTemporal && el.type === 'punto')
      .flatMap(el => el.data);

    // 3. Preparar el payload SOLO con los elementos seleccionados
    const payload = {
      name: mapName,
      data: {
        lineas: [],
        puntosInteres: [],
        poligonos: []
      }
    };

    // 4. Procesar SOLO los elementos seleccionados (ignorar temporales que no están en selectedElements)
    selectedElements.forEach(element => {
      try {
        if (!element || !element.type) return;

        // Saltar elementos temporales que se manejan por separado
        if (element.isTemporal) return;

        switch (element.type) {
          case 'punto':
            // Filtrar marcadores eliminados antes de guardar
            const puntosToSave = element.data.filter(punto => {
              const markerId = String(punto.id || punto.nombre || punto.temporalId);
              return !savedDeletedMarkers.includes(markerId);
            });

            if (puntosToSave.length > 0) {
              payload.data.puntosInteres.push(...puntosToSave.map(punto => ({
                nombre: element.nombre, // Usar el nombre del grupo
                direccion: punto.direccion || '',
                localidad: punto.localidad || '',
                lat: punto.lat?.toString() || '0',
                lng: punto.lng?.toString() || '0',
                icono: punto.icono || 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png'
              })));
            }
            break;

          case 'bus':
          case 'linea':
            if (Array.isArray(element.data)) {
              payload.data.lineas.push({
                linea: element.nombre, // Nombre completo de la línea (ej: "117", "117B")
                lat: element.data[0]?.lat?.toString() || '0',
                lng: element.data[0]?.lng?.toString() || '0',
                color: element.color || element.data[0]?.color || '#FF0000',
                sequence_order: element.data[0]?.sequence_order || 0
              });
              
              // Agregar todos los puntos de la línea
              element.data.forEach((point, index) => {
                payload.data.lineas.push({
                  linea: element.nombre,
                  lat: point.lat?.toString() || '0',
                  lng: point.lng?.toString() || '0',
                  color: point.color || element.color || '#FF0000',
                  sequence_order: point.sequence_order || index + 1
                });
              });
            }
            break;

          case 'polygon':
            if (Array.isArray(element.data)) {
              element.data.forEach((p, i) => {
                payload.data.poligonos.push({
                  nombre_zona: element.nombre,
                  lat: p.lat?.toString() || '0',
                  lng: p.lng?.toString() || '0',
                  color: p.color || element.color || '#388e3c',
                  punto_orden: p.punto_orden || i + 1
                });
              });
            }
            break;
        }
      } catch (error) {
        console.error(`Error procesando ${element?.type} ${element?.nombre}:`, error);
      }
    });

    // 5. Agregar marcadores temporales como un nuevo grupo de puntos
    if (temporalMarkersToSave.length > 0 && newListName) {
      temporalMarkersToSave.forEach(marker => {
        payload.data.puntosInteres.push({
          nombre: newListName,
          direccion: marker.direccion || '',
          localidad: marker.localidad || '',
          lat: marker.lat?.toString() || '0',
          lng: marker.lng?.toString() || '0',
          icono: marker.icono || 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png'
        });
      });
    }

    // 6. Verificación de datos mínimos
    if (payload.data.puntosInteres.length === 0 && 
        payload.data.lineas.length === 0 && 
        payload.data.poligonos.length === 0) {
      throw new Error('El mapa debe contener al menos un elemento (punto, línea o polígono)');
    }

    console.log('Datos a enviar (solo elementos seleccionados):', payload);

    // 7. Envío al backend - IMPORTANTE: NO enviar el mapa existente
    const response = await axios.post('https://mapa.ne3publicidad.com.ar/api/api/updateMap', {
      name: mapName,  // Solo el nombre nuevo
      lineas: payload.data.lineas,
      puntosInteres: payload.data.puntosInteres,
      poligonos: payload.data.poligonos
      // NO enviar 'map' (el mapa existente)
    });
    
    // 8. Limpieza post-guardado
    localStorage.removeItem('deletedMarkers');
    setDeletedMarkers([]);

    // Feedback al usuario
    setAlertMessage('Mapa guardado exitosamente');
    setAlertSeverity('success');
    setAlertOpen(true);
    
    // 9. Resetear el estado
    closeSaveMapPopup();
    setMapName('');
    setNewListName('');
    setTemporalMarkers([]);
    setSelectedElements([]); // Limpiar elementos seleccionados
    setFilters({
      punto: '',
      linea: '',
      poligono: '',
    });

  } catch (error) {
    console.error('Error al guardar el mapa:', error);
    setAlertMessage(error.response?.data?.message || error.message || 'Error al guardar el mapa');
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

//limpia el poligono 
useEffect(() => {
  return () => {
    if (currentPolygon) {
      currentPolygon.setMap(null);
    }
  };
}, [currentPolygon]);

const drawPolygon = (data) => {
  if (map && data.length > 0) {
    const coordinates = data.map(row => ({
      lat: parseFloat(row.lat),
      lng: parseFloat(row.lng),
    }));

    // Si ya existe un polígono en el mapa, lo elimina antes de dibujar uno nuevo
    if (polygon) {
      polygon.setMap(null);
    }

    // Crear el polígono con las coordenadas del archivo Excel
    const newPolygon = new window.google.maps.Polygon({
      paths: coordinates,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      draggable: false, // No permite arrastrar el polígono
      editable: false,  // No permite editar el polígono
    });

    newPolygon.setMap(map);
    setPolygon(newPolygon);
  }
};
const fetchData = async () => {
  if (filters.punto) {
    const response = await axios.get(`https://mapa.ne3publicidad.com.ar/api/api/getPuntosInteres/${filters.punto}`);
    const data = response.data;
    const groupedData = data.reduce((acc, punto) => {
      if (!acc[punto.nombre]) {
        acc[punto.nombre] = [];
      }
      acc[punto.nombre].push(punto);
      return acc;
    }, {});
    setPuntosInteres(groupedData);
  } else {
    setPuntosInteres([]);
  }

  if (filters.poligono) {
    const response = await axios.get(`https://mapa.ne3publicidad.com.ar/api/api/getPolygonPoints/${filters.poligono}`);
    const data = response.data;
    const groupedData = data.reduce((acc, poligono) => {
      if (!acc[poligono.nombre_zona]) {
        acc[poligono.nombre_zona] = [];
      }
      acc[poligono.nombre_zona].push(poligono);
      return acc;
    }, {});
    setPoligonos(groupedData);
  } else {
    setPoligonos([]);
  }
};

//maneja la logica de la creacion del poligono manualmente 
const handlePolygonCreationToggle = () => {
  if (isCreatingPolygon) {
    // Finalizar la creación
    if (currentPolygon) {
      const paths = currentPolygon.getPath().getArray();
      if (paths.length >= 3) { // Un polígono válido necesita al menos 3 puntos
        setPolygonDialogOpen(true);
      } else {
        setAlertMessage('Un polígono debe tener al menos 3 puntos');
        setAlertSeverity('error');
        setAlertOpen(true);
        cancelPolygonCreation();
      }
    }
  } else {
    // Comenzar la creación
    startPolygonCreation();
  }
};

const startPolygonCreation = () => {
  // Limpiar polígono actual si existe
  if (currentPolygon) {
    currentPolygon.setMap(null);
  }

  const newPolygon = new window.google.maps.Polygon({
    strokeColor: polygonColor,
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: polygonColor,
    fillOpacity: 0.35,
    editable: true,
    draggable: true,
    map: map
  });

  setCurrentPolygon(newPolygon);
  setIsCreatingPolygon(true);
};

const cancelPolygonCreation = () => {
  if (currentPolygon) {
    currentPolygon.setMap(null);
    setCurrentPolygon(null);
  }
  setIsCreatingPolygon(false);
};

//funcion para guardar o cancelar poligono 
const handleCancelPolygonSave = () => {
  cancelPolygonCreation();
  setPolygonDialogOpen(false);
  setZona('');
};

const handleSaveManualPolygon = async () => {
  if (!currentPolygon || !zona) return;

  try {
    const paths = currentPolygon.getPath().getArray();
    const puntos = paths.map(point => ({
      lat: point.lat(),
      lng: point.lng()
    }));

    // Llamar al endpoint para guardar el polígono
    await axios.post('https://mapa.ne3publicidad.com.ar/api/api/savePolygon', {
      nombre_zona: zona,
      puntos: puntos,
      color: polygonColor
    });

    // Convertir el polígono a no editable
    currentPolygon.setOptions({
      editable: false,
      draggable: false
    });

    // Agregar el polígono a la lista de elementos seleccionados
    const polygonElement = {
      nombre: zona,
      type: 'polygon',
      data: puntos.map((p, i) => ({
        nombre_zona: zona,
        lat: p.lat.toString(),
        lng: p.lng.toString(),
        color: polygonColor,
        punto_orden: i + 1
      })),
      polygon: currentPolygon
    };

    setSelectedElements(prev => [...prev, polygonElement]);
    
    // Resetear estados
    setCurrentPolygon(null);
    setIsCreatingPolygon(false);
    setPolygonDialogOpen(false);
    setZona('');
    
    // Mostrar mensaje de éxito
    setAlertMessage('Polígono guardado exitosamente');
    setAlertSeverity('success');
    setAlertOpen(true);
  } catch (error) {
    console.error('Error al guardar el polígono:', error);
    setAlertMessage('Error al guardar el polígono');
    setAlertSeverity('error');
    setAlertOpen(true);
  }
};

const handleSave = () => {
  if (!zona || data.length === 0) {
    setAlertMessage('Zona o datos faltantes');
    setAlertSeverity('error');
    setAlertOpen(true);
    return;
  }

  axios.post('https://mapa.ne3publicidad.com.ar/api/api/savePolygon', {
    nombre_zona: zona,
    puntos: data,
  })
    .then((response) => {
      setAlertMessage('Datos guardados exitosamente');
      setAlertSeverity('success');
      setAlertOpen(true);

      // Limpiar el contenedor del archivo y el campo de entrada
      setData([]);
      setExcelCargado(false);
      setZona('');
      document.getElementById('file-upload').value = ''; // Limpiar el input de archivo
      if (polygon) {
        polygon.setMap(null); // Limpiar el polígono del mapa
        setPolygon(null);
      }
    })
    .catch((error) => {
      setAlertMessage('Error al guardar los datos');
      setAlertSeverity('error');
      setAlertOpen(true);
    });
};

return (
  <div>
    <Box className="container">
      {/* Contenedor principal de controles */}
      <Box className="main-controls">
        {/* Botones superiores */}
        <Box display="flex" justifyContent="flex-end" gap={2} mb={2}>
          <Button
            className={`create-polygon-button ${isCreatingPolygon ? "creating" : ""}`}
            variant="contained"
            startIcon={<img src="https://img.icons8.com/?size=100&id=Si0V2yDb01x6&format=png&color=000000" alt="Crear Forma" width="24" height="24" />}
            onClick={handlePolygonCreationToggle}
          >
            {isCreatingPolygon ? "Finalizar forma" : "Crear forma"}
          </Button>

          <Button
            id="edit-map-save-button"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={openSaveMapPopup}
          >
            Guardar Mapa
          </Button>
        </Box>

        {/* Filtros superiores */}
        <Box className="filters-container" display="flex" justifyContent="space-between" mb={2}>
          {/* Autocomplete para Puntos de Interés */}
          <Box className="filter">
            <Autocomplete
              className="custom-autocomplete"
              options={Object.keys(puntosInteres).filter(nombre => 
                !selectedElements.some(el => el.nombre === nombre && el.type === 'punto')
              )}
              getOptionLabel={(option) => option}
              onInputChange={(event, newValue) => setFilters({ ...filters, punto: newValue })}
              onChange={(event, newValue) => {
                if (newValue) {
                  const puntoData = puntosInteres[newValue].map(p => ({
                    ...p,
                    lat: p.lat?.toString(),
                    lng: p.lng?.toString()
                  }));
                  handleSelectElement(newValue, puntoData, 'punto');
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Capa Marcador"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Box>

          {/* Autocomplete para Polígonos */}
          <Box className="filter">
            <Autocomplete
              className="custom-autocomplete"
              options={Object.keys(poligonos).filter(nombre => 
                !selectedElements.some(el => el.nombre === nombre && el.type === 'polygon')
              )}
              getOptionLabel={(option) => option}
              onInputChange={(event, newValue) => setFilters({ ...filters, poligono: newValue })}
              onChange={(event, newValue) => {
                if (newValue) {
                  const polygonData = poligonos[newValue].map((p, i) => ({
                    ...p,
                    punto_orden: i + 1,
                    lat: p.lat,
                    lng: p.lng
                  }));
                  handleSelectElement(newValue, polygonData, 'polygon');
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Capa Forma"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          </Box>
        </Box>

        {/* Buscador de direcciones */}
        <Box 
          id="direccion-buscar-box"
          className="direccion-buscar-container" 
          sx={{ mt: 2, display: 'flex', gap: 1 }}
        >
          <TextField
              className="direccion-buscar-field" // ← Añade esto
              id="direccion-buscar-input"
              label="Buscar dirección"
              value={searchAddress}
              onChange={(e) => setSearchAddress(e.target.value)}
              fullWidth={false} // ← Esto es importante
            />
          <Button 
            id="buscar-direccion-button"
            className="custom-buscar-button"
            variant="contained" 
            onClick={handleSearchAddress}
          >
            Buscar y Añadir
          </Button>
        </Box>

        {/* Listas de capas */}
        <Grid container spacing={2} mt={2}>
          <Grid item xs={4}>
            <Box>
              <h3>Capa Marcador</h3>
              <List>
                {selectedElements
                  .filter(el => el.type === 'punto')
                  .map((element) => (
                    <ListItem key={element.nombre}>
                      <ListItemText 
                        primary={`${element.nombre} (${element.count || element.data.length})`} 
                        secondary={`${element.data.length} marcadores`}
                      />
                      <IconButton 
                        edge="end" 
                        aria-label="delete" 
                        onClick={() => handleRemoveElement(element.nombre, 'punto')}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </ListItem>
                  ))}
              </List>
            </Box>
          </Grid>
          
          <Grid item xs={4}>
            <Box>
              <h3>Capa Forma</h3>
              <List>
                {selectedElements
                  .filter(el => el.type === 'polygon')
                  .map(element => (
                    <ListItem key={element.nombre}>
                      <ListItemText primary={element.nombre} />
                      <IconButton 
                          edge="end" 
                          aria-label="delete" 
                          onClick={() => handleRemoveElement(element.nombre, 'polygon')}
                        >
                          <DeleteIcon />
                        </IconButton>
                    </ListItem>
                  ))}
              </List>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Contenedor del mapa con elementos flotantes */}
      <Box className="map-container">
        {/* Acordeón de buses en posición flotante */}
      
        <Box className="editmap-accordion floating-accordion">
  <BusCheckboxes 
    selectedElements={selectedElements} 
    handleSelectElement={handleSelectElement}
    handleRemoveElement={handleRemoveElement}
    // Pasar las rutas que deben estar marcadas al inicio (del JSON)
    initialSelectedRoutes={availableBusRoutes}
    // Pasar los datos completos de las líneas del JSON
    mapLinesData={mapLinesFromJson}
  />
</Box>
        {/* Mapa */}
        <div id="map" className="map"></div>
      </Box>

      {/* Diálogos */}
      <Dialog open={newPointDialogOpen || iconDialogOpen} onClose={() => {
        setNewPointDialogOpen(false);
        setIconDialogOpen(false);
        setMarkerToEdit(null);
      }}>
        <DialogTitle>
          {markerToEdit ? "Seleccionar ícono para marcador" : "Agregar Capa Marcador"}
        </DialogTitle>
        <DialogContent>
          {markerToEdit && (
            <Box mb={2}>
              <Typography variant="subtitle1">Ubicación:</Typography>
              <Typography variant="body2">{markerToEdit.direccion}</Typography>
              <Typography variant="body2">Coordenadas: {markerToEdit.lat?.toFixed(6)}, {markerToEdit.lng?.toFixed(6)}</Typography>
            </Box>
          )}
          
          {!markerToEdit && (
            <TextField
              autoFocus
              margin="dense"
              label="Nombre del Marcador"
              fullWidth
              value={newPointName}
              onChange={(e) => setNewPointName(e.target.value)}
            />
          )}
          
          <IconSelector 
            selectedIcon={selectedIcon}
            onSelectIcon={(icon) => {
              setSelectedIcon(icon);
              if (markerToEdit) {
                handleAddTemporalMarker(icon);
              }
            }}
          />

          {!markerToEdit && (
            <Typography variant="body2" color="textSecondary" mt={2}>
              Posición: {newPointPosition?.lat.toFixed(6)}, {newPointPosition?.lng.toFixed(6)}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setNewPointDialogOpen(false);
            setIconDialogOpen(false);
            setMarkerToEdit(null);
          }}>
            Cancelar
          </Button>
          {!markerToEdit && (
            <Button 
              onClick={handleSaveNewPoint}
              disabled={!newPointName}
              color="primary"
            >
              Guardar Marcador
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog open={polygonDialogOpen} onClose={() => setPolygonDialogOpen(false)}>
        <DialogTitle>Guardar Forma</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre de la Forma"
            fullWidth
            value={zona}
            onChange={(e) => setZona(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Typography variant="subtitle1" gutterBottom>
            Color de la forma:
          </Typography>
          <ColorPicker 
            selectedColor={polygonColor} 
            onChange={setPolygonColor}  
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelPolygonSave}>Cancelar</Button>
          <Button onClick={handleSaveManualPolygon} disabled={!zona}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={saveMarkersDialogOpen} onClose={() => setSaveMarkersDialogOpen(false)}>
        <DialogTitle>Guardar nueva lista</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre de la nueva lista"
            fullWidth
            value={newListName}
            onChange={(e) => setNewListName(e.target.value)}
          />
          <Typography variant="body2" sx={{ mt: 2 }}>
            {combinedMarkers.length} marcadores serán guardados.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSaveMarkersDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleSaveCombinedMarkers}>Guardar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={saveMapOpen} onClose={closeSaveMapPopup}>
        <DialogTitle>Guardar Mapa</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre del Mapa"
            fullWidth
            value={mapName}
            onChange={(e) => setMapName(e.target.value)}
          />
          
          {temporalMarkers.length > 0 && (
            <>
              <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                Tienes {temporalMarkers.length} marcadores temporales que no han sido guardados.
              </Typography>
              <TextField
                margin="dense"
                label="Nombre para los marcadores"
                fullWidth
                value={newListName}
                onChange={(e) => setNewListName(e.target.value)}
                sx={{ mt: 2 }}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSaveMapPopup}>Cancelar</Button>
          <Button onClick={() => {
            if (temporalMarkers.length > 0) {
              handleSaveTemporalMarkers().then(handleSaveMap);
            } else {
              handleSaveMap();
            }
          }}>Guardar</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
    <Button
      id="limpiar-marcador"
       variant="contained"
  onClick={() => {
    localStorage.removeItem('deletedMarkers');
    setDeletedMarkers([]);
    // Forzar re-renderizado
    setSelectedElements(prev => [...prev]);
  }}
  disabled={deletedMarkers.length === 0}
>
  Limpiar marcadores eliminados
</Button>
  </div>
);

};

export default EditMapPage;
